import React from 'react';
import { Button } from '../../components/ui/button';
import {
  Upload, Eye, Trash2, FileText,
} from 'lucide-react';
import { etiquetaOrigen } from './useAbsorbidos';

const DocumentosAbsorbidos = ({ documentos, onPreviewDoc }) => (
  <div className="mt-6" data-testid="documentos-absorbidos">
    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">De casos fusionados en este (solo lectura)</p>
    <div className="space-y-2">
      {documentos.map(doc => (
        <div key={`${doc.caso_origen?.id}-${doc.id}`} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg border border-dashed border-slate-200"
          data-testid={`documento-absorbido-${doc.id}`}>
          <div className="flex items-center gap-3">
            <FileText size={20} className="text-slate-400" />
            <div>
              <p className="font-medium text-sm text-slate-800">{doc.nombre}</p>
              <p className="text-xs text-slate-500">{doc.tipo} - {doc.subido_por} - {new Date(doc.fecha).toLocaleDateString()}</p>
              <span className="inline-block mt-1 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-slate-200 text-slate-700"
                title={doc.caso_origen?.id} data-testid="documento-absorbido-origen">{etiquetaOrigen(doc.caso_origen)}</span>
            </div>
          </div>
          <button onClick={() => onPreviewDoc(doc)} className="p-1.5 rounded hover:bg-slate-200" data-testid={`documento-absorbido-ver-${doc.id}`}>
            <Eye size={16} className="text-slate-600" />
          </button>
        </div>
      ))}
    </div>
  </div>
);

export const CasoDocumentosTab = ({
  caso, dragOver, onDragOver, onDragLeave, onDrop,
  onOpenUpload, onPreviewDoc, onDeleteDoc, documentosAbsorbidos = [],
}) => (
  <div>
    <div className="flex justify-end mb-4">
      <button onClick={onOpenUpload}
        className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md text-white" style={{ backgroundColor: '#7c3aed' }}>
        <Upload size={14} />Subir Documentos
      </button>
    </div>
    {caso.documentos?.length === 0 ? (
      <div className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors cursor-pointer ${dragOver ? 'border-purple-500 bg-purple-50' : 'border-slate-300 hover:border-purple-400'}`}
        onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={onDrop} onClick={onOpenUpload}>
        <Upload size={32} className="mx-auto mb-2 text-slate-400" />
        <p className="text-slate-500">Arrastre archivos aquí o haga clic para subir</p>
      </div>
    ) : (
      <div className="space-y-2">
        {caso.documentos?.map(doc => (
          <div key={doc.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
            <div className="flex items-center gap-3">
              <FileText size={20} className="text-slate-400" />
              <div>
                <p className="font-medium text-sm text-slate-800">{doc.nombre}</p>
                <p className="text-xs text-slate-500">{doc.tipo} - {doc.subido_por} - {new Date(doc.fecha).toLocaleDateString()}</p>
              </div>
            </div>
            <div className="flex items-center gap-1">
              <button onClick={() => onPreviewDoc(doc)} className="p-1.5 rounded hover:bg-slate-200"><Eye size={16} className="text-slate-600" /></button>
              <button onClick={() => onDeleteDoc(doc.id)} className="p-1.5 rounded hover:bg-red-100 text-red-500"><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    )}
    {documentosAbsorbidos.length > 0 && <DocumentosAbsorbidos documentos={documentosAbsorbidos} onPreviewDoc={onPreviewDoc} />}
  </div>
);
